export enum SectionPermissionTypeEnum {    
    ADMINISTRATION = 1,
    CLIENT_MANAGEMENT,
    USERS_CLIENT,
    ROLES,
    ORGANIZATIONAL_STRUCTURE,
    SURVEY_UPLOAD,
    TEMPLATES,
    CAMPAIGNS,
    SURVEYS,
    PARTICIPANTS,
    GENERAL_PARAMETERS,
    SENTIMENT_PARAMETERS,
    ALERT_PARAMETERS,
    EVENTS,
    COMPLAINT_REOPEN_REASON,
    COMPLAINT_CLOSE_REASON,
    FUNCTIONAL_AREAS,
    SERVICES,
    CLAIMS,
    AUDIT,
    GLOBAL_DASHBOARD,
    SURVEYS_PATIENTS,
    SOCIAL_NETWORKS,
    SURVEYS_PROFESSIONALS,
    ALERTS,
    IMPROVEMENT_PLANS,
    FOLLOWUP_DEMAND,
    ALERT_CONFIG,
    TOPIC_MANAGEMENT,
    DEMAND_CANCEL_REASON,
    DEMAND_IN_FORMAT,
    DEMAND_OUT_FORMAT,
    DEMAND_DERIVATION,
    CLAIM_REQUEST_TYPE,
    EXTRA_FIELDS,
    NOTIFICATIONS,
    USER_COMMUNICATION_TYPE,
    CAMPAIGN_CLOSED_REASON,
    PROFESSIONAL_MANAGEMENT,
    REPORT_DEFINITIONS
}
